import { connect } from "react-redux";
import ImageDrawer from "../../../../shared/components/media/ImageDrawer";
import { appActions } from "../../../../redux/actions/in-app";
import { MediaPageProps } from "../../../../types/app/mediaTypes";

type BlogEditorImageDrawerProps = {
  show: boolean;
  onClose: () => void;
  onSelect: (imageUrl: string) => void;
  currentImageUrl?: string | null;
  currentName: string;
  getImageGalleryAction: MediaPageProps["getImageGalleryAction"];
  getImageGalleryRequest: MediaPageProps["getImageGalleryRequest"];
};

const emptyGalleryRequest: MediaPageProps["getImageGalleryRequest"] = {
  request_status: "GET_IMAGE_GALLERY_RESET",
  is_request_processing: false,
  results: [],
  request_data: {
    type: "GET_IMAGE_GALLERY_RESET",
    results: [],
    response: {
      nextPageUrl: null,
      pageNumber: 1,
      pageSize: 12,
      prevPageUrl: null,
      results: [],
      totalNumberOfPages: 1,
      totalNumberOfRecords: 0,
    },
  },
  galleryData: [],
};

const BlogEditorImageDrawer = ({
  show,
  onClose,
  onSelect,
  currentImageUrl,
  currentName,
  getImageGalleryAction,
  getImageGalleryRequest,
}: BlogEditorImageDrawerProps) => {
  return (
    <ImageDrawer
      show={show}
      onClose={onClose}
      onSelect={onSelect}
      currentImageUrl={currentImageUrl}
      currentName={currentName}
      title="Choose blog image"
      subtitle="Select an image from your media library."
      tabLabel="Check library"
      confirmLabel="Insert image"
      emptyStateText="No images found in the media library."
      pageProps={{
        getImageGalleryAction,
        getImageGalleryRequest,
      }}
    />
  );
};

const mapStateToProps = (state: any) => ({
  getImageGalleryRequest:
    state.allInAppReducers?.getImageGalleryReducer || emptyGalleryRequest,
});

const mapDispatchToProps = {
  getImageGalleryAction: (actionPayload: any, isNewBatch = false) =>
    appActions.GetImageGallery(actionPayload, isNewBatch),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BlogEditorImageDrawer);
